module.exports = __webpack_public_path__ + "img/app-icon-example.507ef490.png";